







import c3 from 'c3'
import * as _ from 'lodash'
import * as d3 from 'd3-format'

export default {
  name: 'BarChart'

  props: [
    'id'
    'start'
    'end'
    'data'
    'dataLabels'
    'xAxisCategories'
    'xAxisLabel'
    'yAxisLabel'
    'title'
  ]
  
  chart: {}
    
  methods:
    formatData: (labels, data) ->
      columns = []
      for label, idx in labels
        columns.push _.concat label, data[idx]

      columns

    formatDataPoints: (val) ->
      data_points = []

      for gender in ['woman', 'man', 'hen']
        row = []
        for range, idx in @xAxisCategories
          row.push (val[idx][gender] || []).length
        if row.length > 0 then data_points.push row

      data_points

  mounted: () ->

    @chart = c3.generate
      title: @title
      data: 
        columns: @formatData(@dataLabels, @formatDataPoints(@data))
        type: 'bar'
      bar:
        width:
          ratio: 0.75
      padding:
        left: 32
        right: 16
      bindto: '#' + @id + '_chart'
      axis:
        x:
          label: @xAxisLabel
          type: 'category'
          categories: @xAxisCategories
        y:
          label: @yAxisLabel
          tick:
            format: (x) -> if x % 1 == 0 then x else null 
  watch:
    'data':
      handler: (val) ->
        @chart.load(
          columns: @formatData(@dataLabels, @formatDataPoints(val))
        )
      deep: true
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/elements/BarChart.vue